var map = {
	"./WhatsApp Image 2024-09-11 at 7.09.08 PM.jpeg": 7113,
	"./main-model/design.jpeg": 8693,
	"./main-model/main-model.glb": 4830,
	"./model-1/design.jpeg": 517,
	"./model-1/model-1.glb": 6906,
	"./model-2/design.jpeg": 6778,
	"./model-2/model-2.glb": 2482,
	"./model-3/design.jpeg": 8743,
	"./model-3/model-3.glb": 1546,
	"./model-4/design.jpeg": 6252,
	"./model-4/model-4.glb": 626,
	"./model-5/design.jpeg": 6257,
	"./model-5/model-5.glb": 7786
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6199;